<template>
    <section>
        <div class="container">
            <div class="row justify-center">
                <div class="col-xs-12 col-sm-10">
                    <div class="text-title">Help & FAQ</div>
                    <q-card class="q-mb-lg">
                        <q-card-section :class="{'q-px-xl' : screenSize.gt.sm, 'q-px-md' : screenSize.lt.md}">
                            <img :src="form.productLine.logo" class="img-faqs q-mt-md q-mb-sm" :title="form.productLine.name" />
                            <p>Choose your product to browse the FAQs</p>
                            <div class="row">
                                <div class="col-xs-12 col-sm-6 col-md-4">
                                    <q-select outlined dense class="col-xs-12 col-sm-6 col-md-3 q-mb-md"
                                              bg-color="white"
                                              label="Product Type" stack-label
                                              autocomplete="off"
                                              @input="updateOptions"
                                              v-model="form.productLine" :options="productLines"
                                              option-label="name"
                                              hide-bottom-space />
                                </div>
                            </div>
                        </q-card-section>
                    </q-card>
                </div>
            </div>
            <div class="q-my-lg">

                <div v-if="form.productLine" class="row justify-center text-center q-mb-md">
                    <div class="row q-col-gutter-lg justify-center col-12">
                        <div v-for="category in categories" :key="category" class="col-xs-12 col-sm-10">
                            <q-card class="card-product bg-primary text-white">
                                <q-card-section class="card-body q-pa-none">
                                    <div class="text-subtitle2"><q-icon :name="category.icon" size="md" class="q-ma-sm icon" /> {{ category.name }}</div>
                                </q-card-section>
                            </q-card>
                            <q-list bordered separator class="rounded-borders q-my-md"
                                    v-for="faq in faqsFiltered(category.name)" :key="faq.question">
                                <q-expansion-item :label="faq.question"
                                                  style="margin-right: -1px; box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12); border-radius: 4px;"
                                                  header-style="border-radius: 4px 4px 0 0;"
                                                  header-class="text-primary text-weight-medium text-left bg-grey-2">
                                    <q-card class="text-left" style="border-radius: 4px;">
                                        <q-card-section>
                                            <system-requirements-table v-if="(faq.question).includes('system requirements')" :sysReq="faq.answer" :dense="true" />
                                            <span v-else v-html="faq.answer"></span>
                                        </q-card-section>
                                    </q-card>
                                </q-expansion-item>
                            </q-list>

                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>
<script>
    import { productLines } from '@/plugins/productLines'
    import { faqs } from '@/plugins/faqs'
    import systemRequirementsTable from '@/components/SystemRequirementsTable'

    export default {
        name: "faq",
        components: {
            systemRequirementsTable,
        },
        props: {
            productLineParam: String
        },
        data() {
            return {
                faqs: faqs,
                productLines: Object.keys(productLines)?.map(key => {
                    return productLines[key]
                })?.filter(pl => pl.name.toLowerCase() !== 'lengthwise'),
                categories: [
                    { name: 'Requirements', icon: 'mdi-desktop-classic' },
                    { name: 'License and Subscription', icon: 'mdi-card-text-outline' },
                    { name: 'Activation and Upgrading Help', icon: 'mdi-lock-open-variant-outline' },
                    { name: 'Features and Other Questions', icon: 'mdi-help-box' },
                ],
                form: {
                    productLine: null,
                }
            }
        },
        methods: {
            updateOptions() {
                this.updateRoute()
            },
            faqsFiltered(categoryName) {
                if (this.form.productLine)
                    return this.faqs[this.form.productLine?.name]?.filter(faq => faq.category == categoryName)
                return this.faqs.LoopCAD
            },
            updateProductLine() {

                if (this.productLineParam) {
                    if (Object.keys(productLines)?.map(key => { return productLines[key] })?.find(pl => pl.name.toLowerCase() == this.productLineParam.toLowerCase())) {
                        this.form.productLine = Object.keys(productLines)?.map(key => { return productLines[key] })?.find(pl => pl.name.toLowerCase() == this.productLineParam.toLowerCase());
                    }
                }

                if (this.$route.query.productLine)
                    this.form.productLine = this.productLines?.find(pl => pl.name.toLowerCase() == this.$route.query.productLine.toLowerCase())
                else if (!this.form.productLine) {
                    this.form.productLine = this.productLines[0]
                }

                this.form.selectedTutorial = null
                this.link = null
                this.updateRoute()
            },
            updateRoute() {
                let queryParams = {}
                if (this.form.productLine)
                    queryParams.productLine = this.form.productLine?.name.toLowerCase()

                this.$router.replace({
                    path: this.$route.path,
                    query: queryParams,
                }).catch(err => { })
            },
        },
        computed: {
            screenSize() {
                return this.$q.screen
            },
        },
        created() {
            this.updateProductLine();
        },
        watch: {
            '$route.query.productLine'(newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    this.updateProductLine()
                }
            },
        },
    }
</script>
<style scoped>

    .hoverShadow:hover {
        box-shadow: 0 1px 8px rgb(0 0 0 / 20%), 0 3px 4px rgb(0 0 0 / 14%), 0 3px 3px -2px rgb(0 0 0 / 12%);
    }

        .hoverShadow:hover .icon {
            transition: 0.15s;
            transform: scale(110%);
        }

    .img-faqs {
        max-width: 100%;
        max-height: 55px;
        width: unset;
    }
</style>
